function sharedModeBase(modes: readonly string[]): string | null {
  const shortest = modes.reduce((a, b) => (b.length < a.length ? b : a));

  if (modes.every((m) => m.startsWith(shortest))) return shortest;

  for (const name of modes) {
    const paren = name.indexOf(" (");

    if (paren === -1) continue;

    const candidate = name.slice(0, paren);

    if (modes.every((m) => m.startsWith(candidate))) return candidate;
  }

  return null;
}

function stripModeBase({
  name,
  base,
}: {
  readonly name: string;
  readonly base: string;
}): string {
  const rest = name.slice(base.length).trim();
  return rest.replace(/^\((.*)\)$/, "$1").trim();
}

export function modesValue(modes: readonly string[]): string {
  if (modes.length <= 1) return modes.join(" · ");

  const base = sharedModeBase(modes);

  if (base) {
    const pieces = modes.map((name) =>
      name === base ? base : stripModeBase({ name, base }),
    );
    return pieces.join(" · ");
  }

  if (modes.length <= 3) return modes.join(" · ");

  return `${modes.slice(0, 2).join(" · ")} · +${modes.length - 2} more`;
}
